export const companyName = process.env.REACT_APP_COMPANY_NAME;
export const emailID = process.env.REACT_APP_EMAIL;
export const UAENum = process.env.REACT_APP_PHONE_NUMBER;
export const wpNumber = process.env.REACT_APP_TEMP_WP_NUMBER;
export const ApiLocalUrl = process.env.REACT_APP_BASE_URL;
export const ApiBaseUrl = process.env.REACT_APP_API_LIVE_URL;
export const imgBaseUrl = process.env.REACT_APP_API_LIVE_URL;
export const numRegex= /^\d{0,15}?$/

export const API_Path = {
    fatchBanners: `${ApiBaseUrl}/api/Banners`,
    fatchNewsAndArticles: `${ApiBaseUrl}/api/NewsAndArticles/`,
    
    agentDetails: `${ApiBaseUrl}/api/Agents`,
    
    agencyDetails: `${ApiBaseUrl}/api/Agency`,
    AgenciesDetails: `${ApiBaseUrl}/api/Agencies`,

    propertiesDetails: `${ApiBaseUrl}/api/Properties`,
    recommendPtsDetails: `${ApiBaseUrl}/api/Properties/similar/`,
    propertiesbyAgent: `${ApiBaseUrl}/api/Properties/byagent/`,
    AgentByAgency: `${ApiBaseUrl}/api/Agents/By/`,
    propertyByAgency: `${ApiBaseUrl}/api/Properties/byagency/`,
    
    ProjectsDetails: `${ApiBaseUrl}/api/Projects`,
    similarPjtsDetails: `${ApiBaseUrl}/api/Projects/similar/`,
    recommendedProject: `${ApiBaseUrl}/api/Projects/recommended-searches/`,

    fatchCities: `${ApiBaseUrl}/api/city`,
    fatchLanguages: `${ApiBaseUrl}/api/Types/language`,
    fatchSpecialities: `${ApiBaseUrl}/api/Types/speciality`,

    DeveloperDetails: `${ApiBaseUrl}/api/Developer`,
    
    AreaUnits: `${ApiBaseUrl}/api/AreaUnits`,

    PropertyInquiry: `${ApiBaseUrl}/api/PropertyInquiry`,

    completionType: `${ApiBaseUrl}/api/Types/completion`,

    purposeType: `${ApiBaseUrl}/api/Types/purpose`,
    purposeSaleType: `${ApiBaseUrl}/api/Types/purpose-sale`,
    amenityType: `${ApiBaseUrl}/api/Types/amenity`,
    categoriesType: `${ApiBaseUrl}/api/Types/categories`,
    offeringType: `${ApiBaseUrl}/api/Types/offering`,
    furnishType: `${ApiBaseUrl}/api/Types/furnish`,
    facingDirectionType: `${ApiBaseUrl}/api/Types/facing-direction`,
    facingViewType: `${ApiBaseUrl}/api/Types/facing-view`,

    addSubscriber: `${ApiBaseUrl}/api/Subscriber`,
    getcountrycodeIp: `https://ipapi.co/json/`,
    contactUS: `${ApiBaseUrl}/api/ContactUs`,

    developerLists: `${ApiBaseUrl}/api/Developer/`,
    selectDevName: `${ApiBaseUrl}/api/Developer/Name`,

    blogList: `${ApiBaseUrl}/api/blogs/pagination?api-version=1`,
    blogDetail: `${ApiBaseUrl}/api/blogs/`,
    blogTrending: `${ApiBaseUrl}/api/blogs/trending?api-version=1`,
    blogCategory: `${ApiBaseUrl}/api/blogcategory?api-version=1`,
    categoryWiseBlog: `${ApiBaseUrl}/api/blogs/pagination/category/`,
    
};